/** Tenant fund flow /metering/finance/new-fundFlow (fundFlow.vue) */
export default {
  fundFlowPage: {
    phDateStart: 'Start date',
    phDateEnd: 'End date',
    phTenant: 'Tenant name / ID',
    phChannel: 'Channel',
    btnSearch: 'Search',
    btnReset: 'Reset',
    btnExport: 'Export',
    btnExporting: 'Exporting…',
    sortDefault: 'Default sort',
    ariaFlowTabList: 'Flow type',
    ariaFormula: 'Tenant retention formula',
    tabElectric: 'Electricity',
    tabWater: 'Water',
    formulaTotal: 'Total retention (CNY)',
    formulaElec: 'Electricity retention (CNY)',
    formulaWater: 'Water retention (CNY)',
    sectionElectric: 'Electricity turnover',
    sectionWater: 'Water turnover',
    colId: 'Reference no.',
    colCreateTime: 'Time',
    colTenant: 'Tenant',
    colOperate: 'Type',
    colChannel: 'Channel',
    colAmount: 'Amount (CNY)',
    colBalance: 'Balance (CNY)',
    colRemark: 'Remark',
    colDetail: 'Details',
    detailColAmount: 'Amount',
    detailColDeductSub: 'Deduct sub-account',
    detailColCashSub: 'Cash sub-account',
    detailRemain: 'Remaining',
    detailEmpty: 'No breakdown',
    btnViewDetail: 'View',
    shortcut7: 'Last 7 days',
    shortcut15: 'Last 15 days',
    shortcut30: 'Last 30 days',
    filterAll: 'All',
    filterRowFlowType: 'Flow',
    filterRowDate: 'Date',
    filterRowTenant: 'Tenant',
    filterRowChannel: 'Channel',
    msgNoManagerExport: 'Missing project context; export disabled.',
    msgNoDataExport: 'No data to export',
    msgExportOk: 'Export completed.',
    msgExportFail: 'Export failed. Please retry.',
    exportCurrentPage: 'Export current page',
    exportSelected: 'Export selected',
    exportAll: 'Export all',
    warnNoSelectedExport: 'Select rows to export first',
    msgExportOkSelected: 'Exported {count} selected row(s).',
    successExported: 'Exported {count} row(s).',
    successExportedLimit: 'Over {total} rows matched; exported first {count}.',
    exporting: 'Exporting…',
    msgFetchFail: 'Failed to load turnover',
    exportSuffix: '_export_',
    operateUnknown: 'Unknown',
    operate1: 'Top-up',
    operate2: 'Refund',
    operate3: 'Electricity',
    operate4: 'Water',
    operate5: 'Service fee',
    operate6: 'Housing fee',
    operate7: 'Property fee',
    actionRecharge: 'Credit',
    actionDeduct: 'Debit',
    actionOp: 'Action',
    channelVal0: 'WeChat top-up',
    channelVal1: 'Corporate top-up',
    channelVal2: 'Manual top-up',
    channelVal3: 'Standard settlement',
    channelVal4: 'Manual debit',
    channelVal5: 'System adjustment',
    channelVal6: 'Floating tariff',
    channelVal7: 'Shared settlement',
    channelVal8: 'Balance refund',
    channelVal9: 'WeChat refund',
    channelVal10: 'Corporate refund',
    channelVal11: 'Device debit',
    channelUnknown: 'Unknown'
  }
}
